import DataVCarouselChart from './datav-carousel';
export default DataVCarouselChart;
